common.View.create('canvas.blocks.custom.textWithRightSlider.Block', {
    onDOMLoad() {
        this.initSwiper();
    },

    initSwiper() {
        // Set needed data.
        let isNotEditing = this.element.find('.swiper-container').data('is-not-editing'); // User is not editing in backend.
        let isEditing = this.element.find('.swiper-container').data('is-editing'); // User is editing in backend.
        let swiperContainer = this.element.find('.swiper-wrapper').get(0);
        let swiperSlides = this.element.find('.swiper-slide').get();
        let setSlidesPerView = swiperContainer.dataset.slidesPerView; // Get slidesPerView from canvas data.
        let slidesAmount = swiperSlides.length; // Get all swiper slides amount.

        // Clone swiper slides for loop parameter and autoplay parameter, but only do this in the front-end.
        // Because of nature of how the loop mode works (it will rearrange slides), total number of slides must be >= slidesPerView * 2 (source: https://swiperjs.com/swiper-api#param-loop).
        if(isNotEditing) {
            swiperSlides.forEach(slide => {
                let clone = slide.cloneNode(true);
                swiperContainer.appendChild(clone);
            });
        }

        // Adjust slidesPerView based on even or odd number of slides. But only do so if user hasn't manually set his slidesPerView preference in the canvas.
        let adjustedSlidesPerView = slidesAmount % 2 === 0 ? slidesAmount / 2 : (slidesAmount - 1) / 2;

        // Default swiper config.
        let swiperConfig = {
            direction: 'vertical',
            spaceBetween: 32,
            allowTouchMove: false,
            initialSlide: 2,
            breakpoints: {
                320: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: setSlidesPerView > 0 ? setSlidesPerView : adjustedSlidesPerView,
                }
            },
        };

        // Set autoplay and loop on front (when user is not editing).
        if(isNotEditing) {
            swiperConfig.speed = 5000;
            swiperConfig.loop = true;
            swiperConfig.autoplay = {
                delay: 0,
                reverseDirection: false,
                disableOnInteraction: false,
            };
        }

        // Set navigation and mousewheel so user can edit properly in backend.
        if(isEditing) {
            swiperConfig.navigation = {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            };
            swiperConfig.mousewheel = true;
        }

        // Initialize the swiper instance.
        new Swiper('.swiper-container', swiperConfig);
    },
});
